var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27981 20.1721C2.62956 20.1808 1.97643 19.937 1.48037 19.4411C0.505306 18.4658 0.505303 16.8848 1.48 15.909L15.8764 1.51348C16.3723 1.01749 17.0252 0.773768 17.6754 0.782451C18.3257 0.773768 18.9788 1.01755 19.4749 1.51348C20.4499 2.48873 20.4499 4.06977 19.4753 5.04557L5.07883 19.4411C4.58295 19.9371 3.93006 20.1808 3.27981 20.1721Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6753 20.1721C18.3255 20.1808 18.9787 19.937 19.4747 19.4411C20.4498 18.4658 20.4498 16.8848 19.4751 15.909L5.07865 1.51348C4.58278 1.01749 3.92989 0.773768 3.27964 0.782451C2.62933 0.773768 1.97625 1.01755 1.4802 1.51348C0.505135 2.48873 0.505131 4.06977 1.47982 5.04557L15.8763 19.4411C16.3721 19.9371 17.025 20.1808 17.6753 20.1721Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCancel);
export default __webpack_public_path__ + "static/media/light-cancel.49dfea3b.svg";
export { ForwardRef as ReactComponent };